// ----------------------------------------------------------------------------
// Dependencies
// ----------------------------------------------------------------------------
import React, { useState, useMemo, useCallback , useEffect, useRef } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Modal as MuiModal
} from '@mui/material';
import {  Cancel, Edit } from '@mui/icons-material';
import { PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import {
  Button as AntButton,
  Card,
  Col,
  Divider,
  Input,
  Modal as AntModal,
  Row
} from 'antd';
import PasswordRevealInline from 'components/PasswordRevealInline';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { useCurrentOrg } from 'store/organizations/selectors';
import {
  handleEnableDiableUser
} from 'store/users/thunks';
import moment from 'moment'
import Loading from 'components/Loading';


import COLOR from 'utils/constants/color';
import Login_as from 'features/forms/admin/Login_as';
import { handleGetParentForOrg } from 'store/organizations/thunks';
import { useCurrentOrg } from 'store/organizations/selectors';
import SpinLoader from 'components/Loader/SpinLoader';
import { getParentStudents } from 'store/email/thunks';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

// ----------------------------------------------------------------------------
// Styled components
// ----------------------------------------------------------------------------
const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const SectionTitle = styled.p`
  color: black;
  font-size: 17px;
  font-weight: 400;
`;

const Highlight = styled.span`
  font-weight: 600;
`;

const ViewDemo = styled.span`
  color: ${({ color }) => color};
  margin-left: 4px;
`;

const ModalContent = styled.div`
  background: ${COLOR.white};
  border-radius: 3px;
  padding: 16px;
  text-align: center;
`;

const ModalActions = styled(Row)`
  margin-top: 16px;
  justify-content: center;
`;

const ModalContentStudentList = styled.div`
align-items: center;
background-color: white;
border-radius: 3px;
display: inline-flex;
flex-direction: column;
left: 50%;
padding: 16px;
position: absolute;
text-align: center;
top: 50%;
transform: translate(-50%, -50%);
width: 100%;
max-width: 70%;
`;

// ----------------------------------------------------------------------------
// Component
// ----------------------------------------------------------------------------
export default function ParentTable({
  userloading,
  onTabsJump = () => {},
  active_tab
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const org = useCurrentOrg();
  const [searchText, setSearchText] = useState('');
  const [pageInfo, setPageInfo] = useState({ page: 0, rowsPerPage: 100 });
  const [detailUser, setDetailUser] = useState(null);
  const [confirmUser, setConfirmUser] = useState(null);
  const [expandedParent, setExpandedParent] = useState(null);
  const [loadingActionId, setLoadingActionId] = useState(null);
  const [data_loading, setDataLoading] = useState(false);
  const [total_count, setToatalCount] = useState(0);
  const [allPrent, setAllParent] = useState([]) 
  const [openDetailModal, setDetailOpen] = useState(false);
  const [openListModal, setOpenListModal] = useState({open: false, id: null,data: [],loading: false});
  const showAlert = useAlert();
  const prevOrgIdRef = useRef(org?.id);
    async function getParentInfo() {
      try {
        setDataLoading(true)
        const response = await dispatch(handleGetParentForOrg(pageInfo.page*pageInfo.rowsPerPage,pageInfo.rowsPerPage,org.id))
        if (response && response.success) {
          const { total_count, parents } = response.data || {};
          setToatalCount(total_count)
          setAllParent(parents)
        }
      } catch (error) {
  
      } finally {
        setDataLoading(false)
      }
  
    }
  useEffect(() => {
    if (org && org.id) {
      if (active_tab != "parent") return;
      getParentInfo()
    }
  }, [org, pageInfo, active_tab])

  useEffect(() => {
    if (active_tab !== "parent") return;
    if (prevOrgIdRef.current !== undefined && prevOrgIdRef.current !== org?.id) {
      setSearchText('');
    }
    prevOrgIdRef.current = org?.id;
  }, [org?.id, active_tab])

  const baseList = useMemo(
    () => sortBy(allPrent, ['firstName', 'lastName']),
    [allPrent]
  );

  // Filtered by searchText
  const displayed = useMemo(() => {
    if (!searchText) return baseList;
    const q = searchText.toLowerCase();
    return sortBy(
      baseList.filter((u) =>
        `${u.firstName} ${u.lastName}`.toLowerCase().includes(q)
      ),
      ['firstName', 'lastName']
    );
  }, [baseList, searchText]);

  // Current page slice
  const pageRows = useMemo(() => {
    return displayed;
  }, [displayed, pageInfo]);

  // Handlers
  const onSearch = useCallback((e) => {
    setSearchText(e.target.value);
  }, []);

  const onPageChange = useCallback((_, newPage) => {
    setPageInfo((p) => ({ ...p, page: newPage }));
  }, []);

  const onRowsPerPageChange = useCallback((e) => {
    setPageInfo({ page: 0, rowsPerPage: +e.target.value });
  }, []);



  const openConfirm = useCallback((u) => setConfirmUser(u), []);
  const closeConfirm = useCallback(() => setConfirmUser(null), []);



  const handleToggleActive = useCallback(async () => {
    if (!confirmUser) return;
    setLoadingActionId(confirmUser.id);
    const response = await dispatch(handleEnableDiableUser(confirmUser.id, !confirmUser.active));
    if(response){
       setAllParent((prev) => {
        return prev?.map((element) => {
          if (element.id === response.id) {
            return { ...element, active: !confirmUser.active };
          }
          else{
            return element
          }
        })
      })
    }
    setLoadingActionId(null);
    closeConfirm();
  }, [dispatch, confirmUser, closeConfirm]);


  const onAddParent = useCallback((isEdit = false) => {
    navigate('/add-users', {
      state: { userData: isEdit ? detailUser : { role:"parent" }, isEdit }
    });
  }, [navigate, detailUser]);


  const handleOpenStudentListModal = async (event,u) => {
    try{
      event.stopPropagation();
      if(openListModal?.loading) {
        return;
      }
      setOpenListModal((prev) => ({...prev, loading: true, id: u.id}))
      const res = await dispatch(getParentStudents({ parent_id: u.id }))
      if(!res?.data || res?.data?.length === 1){
        showAlert("Not Other Student Found");
        setOpenListModal((prev) => ({...prev, loading: false, id: null}))
        return;
      }
      setOpenListModal({open: true, id: u.id, data: res?.data, loading: false})
    }catch(error){
      console.log(error);
      setOpenListModal((prev) => ({...prev, loading: false, id: null}))
    }

  }

  // Column definitions
  const columns = [
    {
      label: 'School Name', render: (u) => u.school_name ||''},
    { label: 'First Name',    render: (u) => u.firstName },
    { label: 'Last Name',     render: (u) => u.lastName },
    { label: 'Parent of', render: (u) => (
      <span>
        {u.parent_of_student ||''}
      </span>
    ) },
    {
      label: 'Status',
      render: (u) => (
        <Button
          variant="contained"
          color={u.active ? 'primary' : 'secondary'}
          sx={{ fontSize: 12, width: 80 }}
          onClick={(e) => { e.stopPropagation(); openConfirm(u); }}
        >
          {loadingActionId === u.id
            ? <Loading size={18} white />
            : u.active ? 'Enabled' : 'Disabled'}
        </Button>
      )
    },
    {
      label: 'View Students',
      render: (u) => (
        <Button
          variant="contained"
          color="primary"
          sx={{ fontSize: 12, whiteSpace: 'nowrap'}}
          onClick={(e) => { e.stopPropagation(); handleOpenStudentListModal(e,u); }}
        >
          {openListModal.loading && openListModal.id === u.id ? <Loading size={18} white /> : 'View Students'}
        </Button>
      )
    }
  ];
    const openDetail = useCallback((u) => {
      const created = get(u, 'createdAt', '');
      const dateStr = created
        ? moment(parseInt(created)).format('YYYY-MM-DD HH:mm:ss')
        : '';
      setDetailUser({ ...u, date: dateStr });
      setDetailOpen(true);
    }, []);
  
    const closeDetail = useCallback(() => setDetailOpen(false), []);


const handleCloseStudentListModal = () => {
  setOpenListModal({open: false, id: null,data: []})
}

  return (
    <>
    <MuiModal open={openListModal.open} onClose={handleCloseStudentListModal}>
      <ModalContentStudentList>
      <div className="galleryMdlCls" onClick={handleCloseStudentListModal}>
                  <Cancel
                    style={{
                      marginLeft: "5px",
                      position: "absolute",
                      right: 0,
                      top: 0,
                      fontSize: 30,
                      color: "red",
                      background: "white",
                      borderRadius: 20,
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className='flex items-center justify-between w-full' style={{maxWidth: "80%"}}>
                  <div style={{width: "50%", fontSize: "18px", fontWeight: "600"}}>Students</div>
                  <div style={{width: "50%", fontSize: "18px", fontWeight: "600"}}>Teacher</div>
                </div>
        {openListModal?.data?.map((element,index) => {
          return (
            <div className='flex items-center justify-between w-full' style={{maxWidth: "80%"}}>
            <div style={{width: "50%"}} key={element?.id}>{element?.firstName} {element?.lastName}</div>
            <div style={{width: "50%"}} className=''>{element?.teacherData?.firstName} {element?.teacherData?.lastName}</div>
            </div>
          )
        })}
           
      </ModalContentStudentList>
    </MuiModal>
    <SpinLoader dataloader={data_loading} />
      {/* Confirm enable/disable */}
      <MuiModal open={!!confirmUser} onClose={closeConfirm}>
        <ModalContent>
          Are you sure you want to {confirmUser?.active ? 'disable' : 'enable'}{' '}
          {get(confirmUser, 'firstName', '')} {get(confirmUser, 'lastName', '')}?
          <ModalActions>
            <Button onClick={closeConfirm} sx={{ mr: 1 }}>Cancel</Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleToggleActive}
              disabled={loadingActionId === confirmUser?.id}
            >
              Yes
            </Button>
          </ModalActions>
        </ModalContent>
      </MuiModal>

      {/* Detail modal */}
      <AntModal
        title={`${get(detailUser, 'firstName', '')} ${get(detailUser, 'lastName', '')}`}
        open={openDetailModal}
        onCancel={closeDetail}
        footer={null}
        width="60%"
      >
        <Row justify="space-between">
          <AntButton  onClick={() => onAddParent(true)} icon={<Edit />}>
            Edit Profile
          </AntButton>
          <Login_as user={detailUser} />
        </Row>

        <Card type="inner" title="Detail View" style={{ marginTop: 16 }}>
          <Row gutter={16}>
            <Col span={12}>
              <p><strong>First name:</strong> {get(detailUser, 'firstName', '')}</p>
              <p><strong>Username:</strong>   {get(detailUser, 'username', '')}</p>
              <p><strong>Status:</strong>     {detailUser?.active ? 'Enabled' : 'Disabled'}</p>
            </Col>
            <Col span={12}>
              <p><strong>Last name:</strong>  {get(detailUser, 'lastName', '')}</p>
              <p><strong>Password:</strong>   <PasswordRevealInline userId={detailUser?.id} username={detailUser?.username} /></p>
              <p><strong>Parent of:</strong>  {get(detailUser, 'student.firstName', '-')}</p>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={12}>
              <p>
                <strong>School Name:</strong>{' '}
                <span
                  style={{ color: '#1464FF', cursor: 'pointer' }}
                  onClick={() => onTabsJump('see_schools', detailUser)}
                >
                  {get(detailUser, 'schoolName', '')}
                </span>
              </p>
            </Col>
          </Row>
        </Card>
      </AntModal>

      {/* Toolbar & table */}
      <Wrapper>
        <Row align="middle" justify="space-between" style={{ marginBottom: 16 }}>
          <AntButton
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => onAddParent(false)}
          >
            Add Parent
          </AntButton>
          <Input
            placeholder="Search by first + last name"
            value={searchText}
            onChange={onSearch}
            style={{ width: 250 }}
          />
        </Row>

        <SectionTitle>
          View <Highlight>Parent</Highlight> Records.
        </SectionTitle>

        <TableContainer sx={{ backgroundColor: '#fff' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell key={i} sx={{ fontSize: 16, fontWeight: 600, textAlign: 'left' }}>
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {isEmpty(displayed) ? (
                userloading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Loading size={30} />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No results
                    </TableCell>
                  </TableRow>
                )
              ) : (
                pageRows.map((u) => (
                  <React.Fragment key={u.id}>
                    <TableRow
                      hover
                      onClick={() => { openDetail(u); }}
                      sx={{ cursor: 'pointer' }}
                    >
                      {columns.map((col, j) => (
                        <TableCell key={j} sx={{ textAlign: 'left' }}>
                          {col.render(u)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                {!isEmpty(displayed) && (
                  <TablePagination
                    count={total_count}
                    page={pageInfo.page}
                    rowsPerPage={pageInfo.rowsPerPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    backIconButtonProps={{ color: 'secondary' }}
                    nextIconButtonProps={{ color: 'secondary' }}
                  />
                )}
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Wrapper>
    </>
  );
}